import React from 'react';

const SvgMathModulo = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M7.5 4A3.515 3.515 0 004 7.5C4 9.421 5.579 11 7.5 11S11 9.421 11 7.5 9.421 4 7.5 4zm8.686.418l-10 14 1.628 1.164 10-14-1.628-1.164zM7.5 6C8.34 6 9 6.66 9 7.5S8.34 9 7.5 9 6 8.34 6 7.5 6.66 6 7.5 6zm9 7a3.515 3.515 0 00-3.5 3.5c0 1.921 1.579 3.5 3.5 3.5s3.5-1.579 3.5-3.5-1.579-3.5-3.5-3.5zm0 2c.84 0 1.5.66 1.5 1.5s-.66 1.5-1.5 1.5-1.5-.66-1.5-1.5.66-1.5 1.5-1.5z" />
  </svg>
);

export default SvgMathModulo;
